import React from "react";
import Chart from "react-apexcharts";

function ChartTeam(prop) {
    if(prop.data != undefined && prop.data.length > 1){
        const series = [prop.data[0].vA_COUNTER, prop.data[0].wO_COUNTER, prop.data[0].aB_COUNTER];
    const options = {
        chart: {
            width: '100%'
        },
        colors: ['#E8CD00', '#24DE8F', '#96969B'],
        fill: {
            colors: ['#E8CD00', '#24DE8F', '#96969B']
        },
        markers: {
            colors: ['#fff', '#E91E63', '#9C27B0']
        },
        labels: ['Working', 'Offline'],
        dataLabels: {
            enabled: false,
            enabledOnSeries: undefined,
            style: {
                colors: ['#fff', '#fff']
            },
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]
            },
        },
        legend: {
            show: false
        },
        plotOptions: {
            pie: {
                customScale: 1.1,
                donut: {
                    size: '75%',
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: '22px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: "#333",
                            offsetY: -10,
                            formatter: function (val) {
                                return val
                            }
                        },
                        value: {
                            show: true,
                            fontSize: '28px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 600,
                            color: "#000F9F",
                            offsetY: 5,
                            formatter: function (val) {
                                return val
                            }
                        },
                        total: {
                            show: true,
                            label: 'All Team',
                            fontSize: '11px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontWeight: 400,
                            color: '#41434A',
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b
                                }, 0)
                            }
                        }
                    }
                },
            }
        }
    };
    return (
        <Chart options={options} series={series} type="donut" />
    )
    }
    else{
        return(false)
    }
}

export default ChartTeam














